"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    AsyncPackagedJwtService: ()=>AsyncPackagedJwtService,
    findLongestCommonSuffix: ()=>findLongestCommonSuffix
});
const external_jwt_service_js_namespaceObject = require("./jwt.service.js");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function async_packaged_jwt_service_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else async_packaged_jwt_service_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const getDefaultHref = ()=>{
    try {
        if ('undefined' != typeof location && 'string' == typeof location.href) return location.href;
    } catch (error) {
        console.error(error);
    }
};
const defaultHref = getDefaultHref();
class AsyncPackagedJwtService {
    saveJwt(uniqueKey, jwt) {
        if ('function' == typeof this.storageSet) {
            var _this_storageGet, _this;
            const data = (null == (_this_storageGet = (_this = this).storageGet) ? void 0 : _this_storageGet.call(_this)) || {};
            data[uniqueKey] = jwt;
            this.storageSet(data, uniqueKey);
        }
    }
    getUniqueKeyByPartition(hostname, partition, jwtConfig) {
        const cacheKey = `${hostname}##${partition}`;
        if (!this.uniqueKeyResult[cacheKey]) {
            const partitionUniqueKeys = jwtConfig.partitionToUniqueKeys[partition];
            const targetHostnames = partitionUniqueKeys.reduce((list, uniqueKey)=>{
                const item = jwtConfig.jwtItems[uniqueKey];
                if (item.disabled) return list;
                const baseUrl = null == item ? void 0 : item.baseUrl;
                const urlObj = baseUrl && new URL(baseUrl, defaultHref);
                if (urlObj) list.push(urlObj.hostname);
                return list;
            }, []);
            const targetHostname = findLongestCommonSuffix(hostname, targetHostnames);
            const uniqueKey = partitionUniqueKeys.find((uniqueKey)=>{
                var _jwtConfig_jwtItems_uniqueKey;
                const baseUrl = null == (_jwtConfig_jwtItems_uniqueKey = jwtConfig.jwtItems[uniqueKey]) ? void 0 : _jwtConfig_jwtItems_uniqueKey.baseUrl;
                const urlObj = baseUrl && new URL(baseUrl, defaultHref);
                return urlObj && urlObj.hostname === targetHostname;
            });
            this.uniqueKeyResult[cacheKey] = uniqueKey;
        }
        return this.uniqueKeyResult[cacheKey];
    }
    async getServiceByUniqueKey(uniqueKey) {
        if (!this.jwtServiceMap.has(uniqueKey)) {
            const jwtConfig = await this.getJwtConfig();
            const config = jwtConfig.jwtItems[uniqueKey];
            if (!config) {
                console.error('[AsyncPackagedJwtService] get jwt config failed', {
                    uniqueKey,
                    configs: jwtConfig
                });
                throw new Error(`[AsyncPackagedJwtService] get jwt config failed: ${uniqueKey}`);
            }
            this.jwtServiceMap.set(uniqueKey, new external_jwt_service_js_namespaceObject.BaseJwtService(_object_spread_props(_object_spread({
                uniqueKey,
                ticketQuery: this.ticketQuery
            }, config), {
                saveJwt: (jwt)=>{
                    this.saveJwt(uniqueKey, jwt);
                },
                setPromiseCache: (content)=>{
                    this.promiseCacheObject[uniqueKey] = content;
                },
                getPromiseCache: ()=>this.promiseCacheObject[uniqueKey],
                resetJwt: ()=>{
                    var _this_storageSet, _this;
                    null == (_this_storageSet = (_this = this).storageSet) || _this_storageSet.call(_this, {});
                }
            })));
        }
        return this.jwtServiceMap.get(uniqueKey);
    }
    async getServiceByPartition(partition, hostname) {
        const jwtConfig = await this.getJwtConfig();
        const usedHostname = hostname || this.defaultHostname;
        const uniqueKey = this.getUniqueKeyByPartition(usedHostname, partition, jwtConfig);
        if (!uniqueKey) {
            console.error('[AsyncPackagedJwtService] calculate uniqueKey failed', {
                partition,
                usedHostname,
                configs: jwtConfig
            });
            throw new Error(`[AsyncPackagedJwtService] calculate uniqueKey failed: ${partition} ${usedHostname}`);
        }
        return this.getServiceByUniqueKey(uniqueKey);
    }
    async getJwtInfoByDomainID(domainID, hostname) {
        var _jwtConfig_jwtItems_uniqueKey;
        const jwtConfig = await this.getJwtConfig();
        const partition = jwtConfig.domainIDToPartition[domainID];
        if (!partition) {
            console.error('[AsyncPackagedJwtService] calculate partition failed', {
                domainID,
                configs: jwtConfig
            });
            throw new Error(`[AsyncPackagedJwtService] calculate partition failed: ${domainID}`);
        }
        const usedHostname = hostname || this.defaultHostname;
        const uniqueKey = this.getUniqueKeyByPartition(usedHostname, partition, jwtConfig);
        if (!uniqueKey) {
            console.error('[AsyncPackagedJwtService] calculate uniqueKey failed', {
                partition,
                usedHostname,
                configs: jwtConfig
            });
            throw new Error(`[AsyncPackagedJwtService] calculate uniqueKey failed: ${partition} ${usedHostname}`);
        }
        return {
            uniqueKey,
            baseUrl: null == (_jwtConfig_jwtItems_uniqueKey = jwtConfig.jwtItems[uniqueKey]) ? void 0 : _jwtConfig_jwtItems_uniqueKey.baseUrl
        };
    }
    async getServiceByDomainID(domainID, hostname) {
        const jwtConfig = await this.getJwtConfig();
        const partition = jwtConfig.domainIDToPartition[domainID];
        if (!partition) {
            console.error('[AsyncPackagedJwtService] calculate partition failed', {
                domainID,
                configs: jwtConfig
            });
            throw new Error(`[AsyncPackagedJwtService] calculate partition failed: ${domainID}`);
        }
        return this.getServiceByPartition(partition, hostname);
    }
    async getService(key, hostname) {
        const jwtConfig = await this.getJwtConfig();
        if (key in jwtConfig.domainIDToPartition) return this.getServiceByDomainID(key, hostname);
        return this.getServiceByUniqueKey(key);
    }
    setCache(uniqueKey, jwt) {
        this.promiseCacheObject[uniqueKey] = Promise.resolve(jwt);
        this.saveJwt(uniqueKey, jwt);
    }
    clearAll() {
        var _this_storageSet, _this;
        Object.keys(this.promiseCacheObject).forEach((item)=>{
            delete this.promiseCacheObject[item];
        });
        null == (_this_storageSet = (_this = this).storageSet) || _this_storageSet.call(_this, {});
    }
    getJwt(key) {
        return this.getService(key).then((service)=>service.getJwt());
    }
    logout(key, next) {
        return this.getService(key).then((service)=>service.logout(next));
    }
    onConfigChanged(config) {
        if (config) {
            this.getJwtConfig = ()=>Promise.resolve(config);
            this.uniqueKeyResult = {};
        }
    }
    constructor({ storageGet, storageSet, promiseCacheObject, getJwtConfig, defaultHostname, ticketQuery }){
        _define_property(this, "jwtServiceMap", new Map());
        _define_property(this, "getJwtConfig", void 0);
        _define_property(this, "promiseCacheObject", void 0);
        _define_property(this, "storageSet", void 0);
        _define_property(this, "storageGet", void 0);
        _define_property(this, "defaultHostname", void 0);
        _define_property(this, "uniqueKeyResult", {});
        _define_property(this, "ticketQuery", void 0);
        this.defaultHostname = defaultHostname;
        this.getJwtConfig = getJwtConfig;
        this.promiseCacheObject = promiseCacheObject || {};
        this.storageSet = storageSet;
        this.storageGet = storageGet;
        this.ticketQuery = ticketQuery;
        const data = null == storageGet ? void 0 : storageGet();
        if (data) Object.keys(data).forEach((key)=>{
            const token = data[key];
            if (token) this.promiseCacheObject[key] = Promise.resolve(token);
        });
    }
}
const findLongestCommonSuffix = (str, arr)=>{
    if (!str) return arr[0];
    let longestSuffix = '';
    let shortestMatch = null;
    for (const currentStr of arr){
        if (currentStr === str) return currentStr;
        let suffix = '';
        for(let j = 1; j <= Math.min(str.length, currentStr.length); j++)if (str[str.length - j] === currentStr[currentStr.length - j]) suffix = str[str.length - j] + suffix;
        else break;
        if (suffix.length > longestSuffix.length) {
            longestSuffix = suffix;
            shortestMatch = currentStr;
        } else if (shortestMatch && suffix.length === longestSuffix.length && currentStr.length < shortestMatch.length) shortestMatch = currentStr;
    }
    return shortestMatch || arr[0];
};
exports.AsyncPackagedJwtService = __webpack_exports__.AsyncPackagedJwtService;
exports.findLongestCommonSuffix = __webpack_exports__.findLongestCommonSuffix;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "AsyncPackagedJwtService",
    "findLongestCommonSuffix"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
